export default "__VITE_ASSET__D9zZWmO8__"